/** @format */

import {
  changeHeaderServiceStoreInfo,
  setHeaderServiceStoreInfo,
  setNearbyStores,
  setUserStoreInfoFromCookie,
  setUserStoreName,
  setUserZipCode,
} from './header-location.actions';
import { createReducer, on } from '@ngrx/store';

import {
  HeaderLocation,
  StoreInformationV3,
  StoreByLocationInformation,
} from '@shared/data-access/interfaces';

export const initialHeaderLocationState: HeaderLocation = {
  storeName: '',
  zipCode: '',
  storeInfo: null,
  nearbyStores: null,
};

/**
 * Maps the store information to a consistent format (`StoreInformationV3`) for the header location state.
 */
export const mapHeaderStoreInfo = (storeInfo: StoreInformationV3 | StoreByLocationInformation) => ({
  address1: 'address1' in storeInfo ? storeInfo.address1 : storeInfo.street1,
  address2: 'address2' in storeInfo ? storeInfo.address2 : storeInfo.street2,
  chain: storeInfo.chain,
  city: storeInfo.city,
  country: storeInfo.country,
  curbsideHours: storeInfo.curbsideHours,
  name: storeInfo.name,
  phone: storeInfo.phone,
  state: storeInfo.state,
  status: storeInfo.status,
  store: 'store' in storeInfo ? storeInfo.store : storeInfo.location,
  storeHours: storeInfo.storeHours,
  zipcode: 'zipcode' in storeInfo ? storeInfo.zipcode : storeInfo.zip,
});

export const headerLocationReducer = createReducer(
  initialHeaderLocationState,
  on(setUserStoreName, (state, { storeName }) => ({
    ...state,
    storeName,
  })),
  on(setUserStoreInfoFromCookie, (state, { zipcode, location, name }): HeaderLocation => {
    return {
      ...state,
      storeInfo: {
        ...state.storeInfo,
        name,
        zipcode,
        store: location,
      },
    };
  }),
  on(setUserZipCode, (state, { zipCode }) => ({
    ...state,
    zipCode,
  })),
  on(setHeaderServiceStoreInfo, changeHeaderServiceStoreInfo, (state, { storeInfo }) => ({
    ...state,
    storeInfo: mapHeaderStoreInfo(storeInfo),
  })),
  on(setNearbyStores, (state, { nearbyStores }) => ({
    ...state,
    nearbyStores,
  })),
);
